// extracted by mini-css-extract-plugin
export default {"ariaSkipLinksContainer":"Ai-z"};